import { Button, FormGroup, FormLabel } from 'react-bootstrap';
import { AllStartConvoRequest, UserSimpleView } from 'cb-model';
import { fetchApi, General, makeResetCache, notify, notifyResponse } from 'gossamer-front-end';
import { CompoundResponse, FieldType } from 'gossamer-unified';
import { FormEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PERSONAL_INSTITUTION_ID } from 'cb-unified';

interface CreateUserConvoProps {
  allowChangeRecipient?: boolean;
  recipientUserId?: string;
  subjectText?: string;
  onSent: () => void;
}

export const CreateUserConvo = (props: CreateUserConvoProps) => {
  const [recipient, setRecipient] = useState<string>(props.recipientUserId || '');
  const [subject, setSubject] = useState<string>(props.subjectText || '');
  const [message, setMessage] = useState<string>('');
  const [submitUnattempted, setSubmitUnattempted] = useState(undefined);
  const dispatch = useDispatch();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitUnattempted(false);
    if (!subject || !message) {
      return;
    }
    try {
      const payload: AllStartConvoRequest = {
        subject,
        message,
        toUserIds: [recipient],
        institutionId: PERSONAL_INSTITUTION_ID,
      };
      const resp: CompoundResponse = await fetchApi('POST', '/main/start-convo', payload);
      // reset cache
      const resetCache = makeResetCache(dispatch);
      notifyResponse(resp);
      resetCache('ConvoUserView');
      props.onSent();
    } catch (error) {
      console.error(error.statusCode, error.message);
      notify([error.message, 'danger']);
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <FormGroup id="recipient">
        <FormLabel>Recipient</FormLabel>
        <div>
          <General
            editable={props.allowChangeRecipient ?? true}
            fieldId="recipient"
            field={{
              seq: 5,
              type: FieldType.Reference,
              label: 'Recipient',
              refEntity: UserSimpleView,
            }}
            handleChange={setRecipient}
            validity={!!recipient || submitUnattempted}
            value={recipient}
          />
        </div>
      </FormGroup>
      <br />{' '}
      <FormGroup id="subject">
        <FormLabel>Subject</FormLabel>
        <General
          editable={true}
          fieldId="subject"
          field={{
            seq: 5,
            type: FieldType.Text,
            label: 'Subject',
          }}
          handleChange={setSubject}
          validity={!!subject || submitUnattempted}
          value={subject}
        />
      </FormGroup>
      <br />
      <FormGroup id="message">
        <FormLabel>Message</FormLabel>
        <General
          editable={true}
          fieldId="message"
          field={{
            seq: 5,
            type: FieldType.Text,
            label: 'Message',
          }}
          handleChange={setMessage}
          validity={!!message || submitUnattempted}
          value={message}
        />
      </FormGroup>
      <br />
      <Button variant="primary" size="sm" type="submit">
        Send
      </Button>
    </form>
  );
};
